import { render, staticRenderFns } from "./BranchOrPersonalGiroMin.vue?vue&type=template&id=268b70ab"
import script from "./BranchOrPersonalGiroMin.vue?vue&type=script&lang=js"
export * from "./BranchOrPersonalGiroMin.vue?vue&type=script&lang=js"
import style0 from "./BranchOrPersonalGiroMin.vue?vue&type=style&index=0&id=268b70ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports